import { Typography, Grid2 } from "@mui/material";
import TableRow from "../TableRow";

import classes from './index.module.scss';

const MaterialRow = ({ material, isApproved, isPremium }) => {
  // skip probably empty dummy '' material
  if (material.productList.length === 0) {
    return null;
  }

  return (
    <>
      {
        material.name ? (
          <Grid2 size={12} className={classes.row}>
            <Typography variant="body1">{material.name}</Typography>
          </Grid2>
        ) : null
      }
      <Grid2 size={12}>
        {
          material.productList.map((product) => {
            return (
              <TableRow
                key={product.id}
                product={product}
                isApproved={isApproved}
                isPremium={isPremium}
              />
            )
          })
        }
      </Grid2>
    </>
  )
}


export default MaterialRow;